import request from '../utils/request'
import { getToken } from '../utils/auth'

export function fetchImageList(filter) {
  return request({
    url: '/api/images',
    method: 'get',
    params: {
      filter,
      'access_token': getToken()
    }
  })
}

export function createImage(data) {
  return request({
    url: '/api/images',
    method: 'post',
    params: {
      'access_token': getToken()
    },
    data
  })
}

export function deleteImage(id) {
  return request({
    url: '/api/images/' + id + '/removeWithFile',
    method: 'delete',
    params: {
      'access_token': getToken()
    }
  })
}

